
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="incidentEventTypeForm">
      <div class="">
        <h3 class="form_name">Event Type</h3>


          <div class="input">
            <label for="">Event Type</label>
            <input type="text" class="default_input reference-form" formControlName="EventName" />
           
          </div>

          <div class="input">
            <label for="">Event Description</label>
            <input type="text" class="default_input reference-form" formControlName="EventDescription" />
          </div>

        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(incidentEventTypeForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(incidentEventTypeForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Incident Event Type"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 

          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(incidentEventTypes | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectIncidentEventType(option.id)"
                  *ngFor="let option of result"
                  [value]="option.EventName"
                >
                  {{ option.EventName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>

        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Event Name</span>
          <span class="item">Event Description</span>
          <span class="item">Action</span>

        </div>

      <div class="scroll">

      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let incidentEventType of incidentEventTypeFormArray.get('IncidentEventTypes')['controls']; index as i"
        (click)="onEdit(i, incidentEventType.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{incidentEventType.value.EventName}}</span>
          <span class="content">{{incidentEventType.value.EventDescription}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"

            (click)="deleteIncidentEventType(i, incidentEventType.value)">
            <em class="ti-trash"> </em> </button>
          </span>

        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(incidentEventTypeFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>

  <div class="box green_box"></div>
  <div class="box pink_box"></div>
